"use strict";

import "../../scss/pages/map-index.scss";
import TomSelect from "tom-select/dist/js/tom-select.complete.min";

import { translationCountryNames } from '../helpers/TranslationCountries';
import axios from "axios";
import GlobalError from "../helpers/globalError";
import ToggleDarkMode from "../helpers/ToggleDarkMode";
import ModalDownloadMobileApp from "../components/modal-download-mobile-app";
import Environment from "../helpers/Environment";
import { MapLegendGenerator } from "../components/mapLegendGenerator";

document.addEventListener("DOMContentLoaded", function () {
	const searchParams = new URLSearchParams(window.location.search);
	const containerInitMessage = document.querySelector('.container-init-message');
	const progressBar = containerInitMessage.querySelector('.progress-init-bar');
	const progressTest = document.querySelector('.progress-test');
	const measurementTest = document.querySelector('#map-measurement-test');
	const measurementResult = document.querySelector('#map-measurement-result');
	const nperfSpeedTest = document.getElementById('nPerfSpeedTest');
	const message = containerInitMessage.querySelector('.init-content');
	const mapVersion = searchParams.get('v') ? parseInt(searchParams.get('v')) : 0;
	const geoInfo = window.location.pathname.split('/')[4];
	let progress = 0;
	const main = document.querySelector('.container-page');
	let mouseMove = false;
	let testRun = false;
	let nPerfReady = false;
	
	if (((sessionStorage.getItem('modalDownloadAppShown') !== 'true') && main) && ((main.dataset.deviceType === 'Mobile Device') || (main.dataset.deviceType === 'Mobile Phone'))) {
		import('../components/modal')
			.then((module) => {
				
				const params = {
					deviceType: main.dataset.deviceType
				}
				const modalModule = new module.Modal();
				modalModule.openModal('modal-download-mobile-app modal-auth modal-slide-up', 'modalDownloadMobileApp', './modal/modal-download-mobile-app', params, ModalDownloadMobileApp.handleOnOpen, ModalDownloadMobileApp.activeSession);
			})
	}
	
	setTimeout(() => {
		if (progressBar) {
			progressBar.parentNode.classList.remove('d-none');
		}
		message.textContent = message.dataset.transMessage;
		containerInitMessage.progress = 50;
		progressBar.style.width = `${ progress }%`;
	}, 2000);

	if(!checkIfCanRunTest()){
		document.querySelector('.map-test-wrapper').classList.add('d-none');
	}

	window.addEventListener('mousemove', function () {
		mouseMove = true;
		if(nPerfReady && !testRun && checkIfCanRunTest()){
			startTest();
		}
	})

	window.addEventListener("message", function (event) {
		if (event.origin === "https://ws."+Environment.getDomain() || event.origin === "https://ws-cdn."+Environment.getDomain()
			|| event.origin === "http://ws-nossl."+Environment.getDomain()) {
			try {
				const { action } = event.data;
				const StepMap = {
					nPerfReady: () => {
						nPerfReady = true;
						if (mouseMove && nperfSpeedTest && checkIfCanRunTest()) {
							startTest();
						}
					},
					nPerfGetLastResult: () => {
						const afterAnimation = () => {
							progressTest.removeEventListener('transitionend', afterAnimation);
							//save localStorage
							localStorage.setItem("autoSpeedTest", new Date().toISOString().split("T")[0]);
							measurementTest.classList.add('d-none');
							measurementTest.classList.add('opacity-0');
							measurementResult.classList.remove('d-none');
							measurementResult.classList.add('anim-module');
							const lastResult = event.data.lastResult.speed;
							let downloadResult = formatNumberToMb(lastResult.download.averageExcludingSlowStart);
							let uploadResult = formatNumberToMb(lastResult.upload.averageExcludingSlowStart);
							const latencyResult = lastResult.latency.minimum.toFixed(1);
							if (downloadResult >= 1000) {
								downloadResult = (downloadResult / 1000).toFixed(2) + '<span class="unit"> Gb/s</span>';
							} else {
								downloadResult = downloadResult + '<span class="unit"> Mb/s</span>';
							}
							if (uploadResult >= 1000) {
								uploadResult = (uploadResult / 1000).toFixed(2) + '<span class="unit"> Gb/s</span>';
							} else {
								uploadResult = uploadResult + '<span class="unit"> Mb/s</span>';
							}

							document.querySelector('#downloadResult').innerHTML = downloadResult;
							document.querySelector('#uploadResult').innerHTML = uploadResult;
							document.querySelector('#latencyResult').textContent = latencyResult;
						}
						progressTest.addEventListener('transitionend', afterAnimation);
						progressTest.style.width = "100%";

					}
				}

				if(StepMap[action]){
					StepMap[action]();
				}else{
					if(!testRun) return;
					const duration = 55000;
					const intervalTime = 50;
					if (!progressTest.animationInterval) {
						let progressStatusTest = parseFloat(progressTest.style.width) || 0;

						const increment = (intervalTime / duration) * 100;

						progressTest.animationInterval = setInterval(() => {
							progressStatusTest = Math.min(progressStatusTest + increment, 100);
							progressTest.style.width = `${progressStatusTest}%`;

							if (progressStatusTest >= 100) {
								clearInterval(progressTest.animationInterval);
								progressTest.animationInterval = null;
							}
						}, intervalTime);
					}
				}
			} catch (e) {
				console.debug(e)
			}
		}
	});

	function startTest() {
		nperfSpeedTest.contentWindow.postMessage({
			action: 'nPerfStartTest',
			restart: false,
		}, "*");
		testRun = true;
	}

	function checkIfCanRunTest() {
		const storedDate = localStorage.getItem("autoSpeedTest");
		const today = new Date().toISOString().split("T")[0];

		const canRun = !storedDate || today > storedDate;

		if (canRun) {
			localStorage.removeItem("autoSpeedTest");
		}

		return canRun;
	}
	
	setTimeout(() => {
		
		const mapTypeActions = {
			'country': true,
			'isp': true,
			'mapType': true,
			'fullscreen': true,
			'search': true
		}
		
		const languageSelected = document.querySelector('#dropdownlanguageMenu');
		const config = {
			onUploadProgress: (progressEvent) => {
				const {loaded, total} = progressEvent;
				progress = Math.round((loaded * 100) / total);
				progressBar.style.width = `${ progress }%`;
			}
		}

    const legendGenerator = new MapLegendGenerator();

    legendGenerator.getConfig().catch((err) => console.warn("Config preload failed:", err));


		
		axios.post(`/${ languageSelected.dataset.languageSelected }/map/load-map-component`, {
				mapType: 'ALL',
				mapVersion: mapVersion,
				typeActionsMap: mapTypeActions,
				geoId: geoInfo !== '-' ? parseInt(geoInfo.split('.')[0]) : 0,
			}, config)
      .then(async (response) => {
				const containerModuleMap = document.querySelector('.container-module-map');
				if (progress === 100) {
					containerModuleMap.classList.add('anim-module');
					containerInitMessage.classList.add('anim-container-init');
					containerModuleMap.innerHTML = response.data;

          const mapConnectionType = document.querySelector("#map")?.dataset.mapConnectionType || "ALL";
          await legendGenerator.renderLegend('.container-legend.bg-legend', mapConnectionType);

        }
				const switchThemeMode = document.querySelector('#toggleColorMode');
				const lightModeImageList = document.querySelectorAll('.light-mode-img');
				const darkModeImageList = document.querySelectorAll('.dark-mode-img');
				
				if (darkModeImageList.length > 0) {
					
					ToggleDarkMode.toggleImageMode(lightModeImageList, darkModeImageList);
					
					switchThemeMode.addEventListener('click', () => {
						ToggleDarkMode.toggleImageMode(lightModeImageList, darkModeImageList);
					});
				}
				
				import('bootstrap/js/dist/button')
					.then()
					.catch(() => 'An error occurred while loading the component');
				
				import('../components/map')
					.then((module) => {
						const mapModule = new module.Map();
						import('bootstrap/js/dist/button')
							.then()
							.catch(() => 'An error occurred while loading the component');
						const containerMapElement = document.querySelector('.container-select-map');
						mapModule.selectMapTypeButton();
						mapModule.initializeMap('signal').then(() => {
								
								mapModule.getCountryList();
								
								containerMapElement.addEventListener("fullscreenchange", () => {
									if (!document.fullscreenElement) {
										mapModule.displayFullScreenElements(containerMapElement, false);
									}
								});
								const regionName = translationCountryNames();
								
								new TomSelect("#selectMapCountry", {
									create: false,
									labelField: 'isoCode',
									valueField: 'isoCode',
									hidePlaceholder: false,
									allowEmptyOption: true,
									placeholder: 'Country',
									plugins: ['dropdown_input'],
									maxOptions: null,
									searchField: ['isoName', 'isoCode'],
									hideSelected: true,
									selectOnTab: false,
									closeAfterSelect: true,
									maxItems: 1,
									render: {
										item: function (item, escape) {
											const latitude = item.bounds.latitude;
											const longitude = item.bounds.longitude;
											return '<div data-minlat="' + escape(latitude.min) + '" data-minlng="' + escape(longitude.min) + '" data-maxlat="' + escape(latitude.max) + '" data-maxlng="' + escape(longitude.max) + '">' +
												'<span class="flag" ><span class="fi fi-' + escape(item.isoCode) + ' fib"></span></span>' +
												'<span class="name">' + escape(item.isoCode.toUpperCase()) + ' <span class="d-none d-sm-inline"> - ' + escape(regionName.of(item.isoCode.toUpperCase())) + '</span></span>' +
												'<span class="name-rtl">' + escape(item.isoCode.toUpperCase()) + '<span class="d-none d-sm-inline"> - ' + escape(regionName.of(item.isoCode.toUpperCase())) + '</span></span>' +
												'</div>';
										},
										option: function (item, escape) {
											const countryCode = item.isoCode === 'reset' ? item.isoCode.toUpperCase() : regionName.of(item.isoCode.toUpperCase());
											const latitude = item.bounds.latitude;
											const longitude = item.bounds.longitude;
											return '<div data-minlat="' + escape(latitude.min) + '" data-minlng="' + escape(longitude.min) + '" data-maxlat="' + escape(latitude.max) + '" data-maxlng="' + escape(longitude.max) + '">' +
												'<span class="flag"><span class="fi fi-' + escape(item.isoCode) + ' fib"></span></span>' +
												'<span class="name">' + escape(item.isoCode.toUpperCase()) + ' - ' + countryCode + '</span>' +
												'<span class="name-rtl">' + escape(item.isoCode.toUpperCase()) + ' - ' + countryCode + '</span>' +
												'</div>';
										}
									},
									onChange: function (event) {
										if (event.length !== 0) {
											mapModule.getIspList();
										} else {
											mapModule.updateHeaderComponent();
											mapModule.updateDescriptionComponent();
										}
									}
								});

								const getIspNameForMapType = (item, mapType) => {
									const name = item[mapType]?.name || item.signal?.name;
									return (name || '').toString();
								};
								new TomSelect("#selectMapIsp", {
									create: false,
									labelField: 'id',
									valueField: 'id',
									allowEmptyOption: true,
									hidePlaceholder: true,
									plugins: ['dropdown_input'],
									searchField: [],
									placeholder: 'Carrier',
									maxOptions: null,
									hideSelected: true,
									closeAfterSelect: true,
									maxItems: 1,
									score: function (query) {
										const normalizedQuery = (query || '').toLowerCase().trim();
										const mapType = mapModule.mapType?.dataset.mapType || 'signal';
										return function (item) {
											const name = getIspNameForMapType(item, mapType).toLowerCase().trim();
											if (!normalizedQuery) {
												return 1;
											}
											return name.startsWith(normalizedQuery) ? 1 : 0;
										};
									},
									render: {
										item: function (item, escape) {
											const mapType = mapModule.mapType?.dataset.mapType || 'signal';
											const ispName = getIspNameForMapType(item, mapType);
											return '<div data-isp-name="' + escape(ispName) + '">' +
												'<i class="fa-solid fa-sim-card"></i>' +
												'<span class="name text-ellipsis">' + escape(ispName) + '</span>' +
												'</div>';
										},
										option: function (item, escape) {
											const mapType = mapModule.mapType?.dataset.mapType || 'signal';
											const ispName = getIspNameForMapType(item, mapType);
											return '<div data-isp-name="' + escape(ispName) + '">' +
												'<span class="name">' + escape(ispName) + '</span>' +
												'</div>';
										}
									},
									onChange: function () {
										mapModule.updateUrl(false, false);
										mapModule.updateHeaderComponent();
										mapModule.updateDescriptionComponent();
										mapModule.toggleOverlay();
									},
								});
								[...document.querySelectorAll('.btn-map-type')].forEach(button => {
									button.addEventListener('change', () => {
										mapModule.selectIsp.tomselect.refreshOptions(false);
									});
								});
								mapModule.mapRef.on('dragend', () => {
									const urlParams = new URLSearchParams(window.location.search);
									const geoInfo = mapModule.getGeolocationInformations(mapModule.mapRef);
									urlParams.set('ll', geoInfo.latitude);
									urlParams.set('lg', geoInfo.longitude);
									urlParams.set('zoom', geoInfo.zoom);
									history.replaceState({nPerf: 'map'}, '', `${ location.pathname }?${ urlParams.toString() }`);
								});
								const mapCanvas = document.querySelector('#map');
								mapCanvas.addEventListener('wheel', (event) => {
									event.stopPropagation();
									if (event.ctrlKey) {
										event.preventDefault();
										mapModule.mapRef.scrollWheelZoom.enable();
										mapModule.updateUrl(false, true);
									} else {
										mapModule.mapRef.scrollWheelZoom.disable();
									}
								})
							}
						);
						
						const toggleMapType = mapModule.toggleMapType.bind(mapModule);
						let mapTypeButtonList = document.querySelectorAll('.btn-map-type');
						[...mapTypeButtonList].forEach(el => el.addEventListener('click', toggleMapType));
						
						new TomSelect("#inputMapSearch", {
							labelField: 'placeId',
							valueField: 'placeId',
							persist: false,
							createOnBlur: false,
							create: false,
							maxItems: 1,
							maxOptions: null,
							searchField: ['name'],
							hideSelected: true,
							load: function (query, callback) {
								mapModule.getResultSearchList(query, callback);
							},
							render: {
								item: function (item, escape) {
									return '<div data-id="' + escape(item.placeId) + '" data-type="' + escape(item.iconName) + '" data-bounding-box="' + escape(item.boundingCoordinates) + '">' +
										'<span class="name">' + escape(item.name) + '</span>' +
										'</div>';
								},
								option: function (item, escape) {
									return '<div data-id="' + escape(item.placeId) + '" data-type="' + escape(item.iconName) + '" data-bounding-box="' + escape(item.boundingCoordinates) + '">' +
										'<i class="' + escape(item.iconName) + '"></i>' +
										'<span class="name">' + escape(item.name) + '</span>' +
										'</div>';
								}
							},
							onChange: function () {
								mapModule.refreshMap();
								mapModule.refreshSearchOptions();
							},
							onDropdownOpen: function () {
								mapModule.refreshSearchOptions();
							}
						});
						
						new TomSelect("#selectTileMap", {
							labelField: 'value',
							valueField: 'value',
							allowEmptyOption: true,
							maxOptions: null,
							create: false,
							options: [
								{value: "arcGis", text: "ArcGIS"},
								{value: "openStreetMap", text: "OpenStreetMap"},
								{value: "arcGisHybrid", text: "ArcGIS Hybrid"},
							],
							controlInput: null,
							items: ['arcGis'],
							hideSelected: true,
							render: {
								item: function (item, escape) {
									return '<div data-tile-name="' + escape(item.value) + '" aria-label="' + escape(item.value) + '">' +
										'<span class="name">' + escape(item.text) + '</span>' +
										'</div>';
								},
								option: function (item, escape) {
									return '<div data-tile-name="' + escape(item.value) + '"  aria-label="' + escape(item.value) + '">' +
										'<span class="name">' + escape(item.text) + '</span>' +
										'</div>';
								}
							},
							onChange: function (event) {
								mapModule.toggleTileMap(event, 'signal');
							}
						});
						
						const buttonFullScreenList = document.querySelectorAll('.btn-full-screen');
						buttonFullScreenList.forEach((buttonFullScreen) => {
							buttonFullScreen.addEventListener('click', () => {
								mapModule.toggleFullscreen();
							});
						});
						
					})
					.catch((error) => {
						console.error("Error loading module:", error);
					});
				
			})
			.catch((error) => {
				if (error.response && error.response.data.errors) {
					GlobalError.openErrorModal(error.response.data.errors.message, 'globalErrorMap');
				}
			});
	}, 2500);
	
	const buttonMapMobileApp = document.querySelectorAll('.btn-map-app');
	buttonMapMobileApp.forEach((mapStoreApp) => {
		mapStoreApp.addEventListener('click', () => {
			/* eslint-disable */
			_paq.push(['trackEvent', 'MapMobileApp', mapStoreApp.dataset.tag]);
			/* eslint-enable */
		})
	});

	function formatNumberToMb(number) {
		return (Math.round(100*(number/1000000))/100).toFixed(1);
	}
	
});
